(function () {
  if (window.branchVariantSyncInitialized) return;
  window.branchVariantSyncInitialized = true;

  let lastSynced = new WeakMap();

  function renderSelectedVariant(variantSelects, onlyOnce) {
    const input = variantSelects.querySelector('fieldset input:checked, select option[selected]');
    const selectedOptionValues = variantSelects.selectedOptionValues;
    if (!input || !selectedOptionValues || !selectedOptionValues.length) return;

    if (onlyOnce) {
      // El marcador sigue presente si Shopify no pudo resolver la variante: no repetir la misma petición.
      const key = selectedOptionValues.join(',');
      if (lastSynced.get(variantSelects) === key) return;
      lastSynced.set(variantSelects, key);
    }

    publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
      data: {
        event: { target: input },
        // Sin id para que product-info no mueva el foco (y el scroll) al selector al terminar.
        target: { dataset: input.dataset },
        selectedOptionValues,
      },
    });
  }

  function syncVariantSelects() {
    document.querySelectorAll('variant-selects').forEach((variantSelects) => {
      if (!variantSelects.querySelector('[data-branch-variant-sync]')) return;
      renderSelectedVariant(variantSelects, true);
    });
  }

  subscribe(PUB_SUB_EVENTS.variantChange, syncVariantSelects);

  window.addEventListener('locationChanged', () => {
    lastSynced = new WeakMap();
    document.querySelectorAll('variant-selects').forEach((variantSelects) => renderSelectedVariant(variantSelects, false));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncVariantSelects);
  } else {
    syncVariantSelects();
  }
})();
